import { StyleSheet, View } from 'react-native';

import { Pressable, Text, tokens } from '@fhs/ui';

import { ActionTileProps } from './types';

export function ActionTileMobile(props: ActionTileProps) {
  return (
    <Pressable style={styles.container} onPress={props.onPress}>
      <View style={styles.iconCircle}>{props.Icon}</View>
      <Text weight="semibold" style={styles.title}>
        {props.title}
      </Text>
      <Text style={styles.subtitle}>{props.subtitle}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
    gap: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
  },
  iconCircle: {
    height: 52,
    width: 52,
    borderRadius: 52,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$houseRedOpacity04,
  },
  title: {
    fontSize: 14,
  },
  subtitle: {
    fontSize: 12,
    lineHeight: 16.8,
  },
});
